import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { TransactionTriggerName } from '@frontend/transaction/types';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useTransactionTriggerSelect from './transaction-trigger-select.controller';

const ID = 'transaction-trigger-select';
export interface TransactionTriggerSelectProps extends Omit<SelectInputV2Props<TransactionTriggerName>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const TransactionTriggerSelect = (props: TransactionTriggerSelectProps) => {
    const viewProps = useTransactionTriggerSelect(props);

    return (
        <SelectInputV2<TransactionTriggerName>
            {...props}
            id={ID + props.id}
            label={props.label || 'Transaction trigger'}
            options={viewProps.options}
        />
    );
};
